import styles from "./allStatus.module.css";
const AllStatusToolTip = ({ dataSource, dataState, getGridData, statCntList, getStatCntList, initDataState, isDeveloper }) => {
  return (
    <div>
      <span
        className={styles.dangerUsers}
        onClick={() => {
          initDataState();
          getStatCntList();
          dataState.dangerElderYn = "Y";
          getGridData();
        }}>  
        {/* <img src="/images/icon_bell.png" alt="bell"></img> */}
        <span>관리 대상자 : &nbsp;&nbsp;&nbsp; {dataState.dangerYnCnt}</span>
      </span>
      <span className={styles.tooltip}>
        <div className={styles.tooltipText}>
          상태/이벤트 도움말&nbsp;
          <img style={{ width: "20px", height: "20px" }} src="/images/info.png" alt="" />
        </div>
        <div className={styles.tooltipImg}>
          <span className={styles.helpTxtTitle} style={{ paddingTop: "5px" }}>
            {"<이벤트>"}
          </span>
          <span className={styles.helpTxtLine}>
            <img className={styles.helpCircleSize} src="/images/chncareimg/icon_gre.png" alt="정상" /> 정상 : 정상적으로 데이터 수집이 되는 상태
          </span>
          <span className={styles.helpTxtLine}>
            <img className={styles.helpCircleSize} src="/images/chncareimg/icon_yl.png" alt="경고" /> 경고 :정상 데이터 수집 되며 4시간 이상 자리비움 지속
            시 <br></br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(온도 40°C 이상 4시간 지속 포함)
            <br></br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(온도 10°C 이하 4시간 이상 지속 포함)
            <br></br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(CO<small>2</small> 1,000 이상 3,000 이하 1시간 이상 지속 포함)
            <br></br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(TVOC 1,000 이상 3,000 이하 1시간 이상 지속 포함)
            <br />
          </span>
          <span className={styles.helpTxtLine}>
            <img className={styles.helpCircleSize} src="/images/chncareimg/icon_rd.png" alt="위험" /> 위험 : 정상 데이터 수집 되며 24시간 이상 자리비움 지속 및 긴급버튼 신호 수신 시
            <br></br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(온도 40°C 이상 24시간 이상 지속 포함)
            <br></br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(온도 10°C 이하 24시간 이상 지속 포함)
            <br></br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(CO<small>2</small> 3,000 초과 1시간 이상 지속 포함)
            <br></br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(TVOC 3,000 초과 1시간 이상 지속 포함)
          </span>
          <span className={styles.helpTxtLine}>
            <img className={styles.helpCircleSize} src="/images/chncareimg/icon_gray.png" alt="미작동" /> 미작동 : 1시간 이상 데이터 미수집 상태 지속
            시
          </span>
          <span style={{color : "#dc4747"}} className={styles.helpTxtLine}>
            &nbsp;&nbsp;&nbsp;&nbsp;설치예정 : 대상예정자
          </span>
          <span className={styles.helpTxtTitle}>{"<상태>"}</span>
          <div className={styles.helpDiv}>
            <img className={styles.helpStateImg} src="/images/mobile/high_activity.png" alt="고활동표시" />
            <div className={styles.helpTxtDiv}>
              <span className={styles.helpTxtLine}> 고활동 : 30분 이상, 움직임 30 이상으로 측정되는 경우</span>
              <span className={styles.helpTxtLine3}>* 3차장비 : 움직임이 존재하고, 속도 2,000 이상으로 측정되는 경우</span>
            </div>
          </div>
          <div className={styles.helpDiv}>
            <img className={styles.helpStateImg} src="/images/mobile/low_activity.png" alt="고활동표시" />
            <div className={styles.helpTxtDiv}>
              <span className={styles.helpTxtLine}> 저활동 : 30분 미만, 움직임 30 이상으로 측정되는 경우</span>
              <span className={styles.helpTxtLine3}>* 3차장비 : 움직임이 존재하고, 속도 2,000 미만으로 측정되는 경우</span>
              <span className={styles.helpTxtLine3}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              또는 움직임이 존재하지 않고, 속도가 존재하는 경우</span>
            </div>
          </div>
          <div className={styles.helpDiv}>
            <img className={styles.helpStateImg} src="/images/mobile/meal.png" alt="고활동표시" />
            <div className={styles.helpTxtDiv}>
              <span className={styles.helpTxtLine}>
                식사 : 움직임 50 이상, CO<small>2</small> 1,500 이상, 조도 10 이상으로 측정되는 경우
              </span>
              <span className={styles.helpTxtLine3}>
                * 3차장비 : 움직임이 존재하고, CO<small>2</small> 600 이상, 조도 10 이상으로 측정되는 경우
              </span>
            </div>
          </div>
          <div className={styles.helpDiv}>
            <img className={styles.helpStateImg} src="/images/mobile/out.png" alt="고활동표시" />
            <div className={styles.helpTxtDiv}>
              <span className={styles.helpTxtLine}>자리비움 : 움직임 30 미만으로 측정되는 경우</span>
              <span className={styles.helpTxtLine3}>* 3차장비 : 움직임이 존재하지 않고, 속도 0 으로 측정되는 경우</span>
            </div>
          </div>
          <div className={styles.helpDiv}>
            <img className={styles.helpStateImg} src="/images/mobile/sleep.png" alt="고활동표시" />
            <div className={styles.helpTxtDiv}>
              <span className={styles.helpTxtLine}>수면 : 움직임이 50 이하, 조도 10 이하로 측정되는 경우</span>
              <span className={styles.helpTxtLine3}>* 3차장비 : 움직임이 존재하지 않고, 속도 0, 조도 10 미만으로 측정되는 경우</span>
            </div>
          </div>
          <span className={styles.helpTxtTitle}>{"<관리 대상자>"}</span>
            <img src="/images/icon_bell.png" style={{ width: "25px" }} alt="위험" /> &nbsp;집중 관리가 필요한 대상자 (최근 일주일 동안 위험 2번이상 발생 시 또는 담당자가 수동으로 설정)
          {/* <span className={styles.helpTxtTitle}>{"<1차 설치제품>"}</span>
          <span className={styles.helpTxtLine}>
            <img src="/images/icon_set.png" style={{ width: "20px" }} alt="시제품" />
            &nbsp;시범사업 진행 시 설치한 시제품 기기(움직임·호흡·온도·습도·소리레벨 측정)
          </span> */}
        </div>
      </span>
      {/* <span className={styles.alertInfoSpan}>
        <span
          className={styles.alertInfoSpanFirst}
          onClick={() => {
            initDataState();
            getStatCntList();
            dataState.dangerElderYn = "Y";
            getGridData();
          }}>
          <img src="/images/icon_bell.png" alt="bell"></img>
          <span>위험 대상자 : &nbsp;&nbsp;&nbsp; {dataState.dangerYnCnt}</span>
        </span>
        &nbsp;&nbsp;&nbsp;
        {dataState.rgnCode === '44130' || isDeveloper() ? 
        <span
          className={styles.alertInfoSpanSecond}
          onClick={() => {
            initDataState();
            getStatCntList();
            dataState.bizType = "5001";
            getGridData();
          }}>
          <img src="/images/icon_set.png" alt="set"></img>1차 설치제품 : &nbsp;&nbsp;&nbsp;
          {statCntList.firstBizCnt !== null ? statCntList.firstBizCnt : 0}
        </span>
        :
        <></>
        }
      </span>
      <span className={styles.statusViewHelp}>
        <span className={styles.statusViewHelpSpan}>
          상태/이벤트 도움말&nbsp;
          <img style={{ width: "20px", height: "20px" }} src="/images/info.png" alt="" />
        </span>
        <div className={styles.statusHelpImg}>
          <span className={styles.helpTxtTitle} style={{ paddingTop: "5px" }}>
            {"<이벤트>"}
          </span>
          <span className={styles.helpTxtLine}>
            <img className={styles.helpCircleSize} src="/images/chncareimg/icon_gre.png" alt="정상" /> 정상 : 정상적으로 데이터 수집이 되는 상태
          </span>
          <span className={styles.helpTxtLine}>
            <img className={styles.helpCircleSize} src="/images/chncareimg/icon_yl.png" alt="경고" /> 경고 :정상 데이터 수집 되며 4시간 이상 부재 지속
            시 <br></br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(온도 40°C 이상 4시간 지속 포함)
            <br />
          </span>
          <span className={styles.helpTxtLine}>
            <img className={styles.helpCircleSize} src="/images/chncareimg/icon_rd.png" alt="위험" /> 위험 : 정상 데이터 수집 되며 24시간 이상 부재/
            <br></br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;수면 지속 및 음성인식/호출기 신호 수신 시
            <br></br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(온도 40°C 이상 24시간 이상 지속 포함)
          </span>
          <span className={styles.helpTxtLine}>
            <img className={styles.helpCircleSize} src="/images/chncareimg/icon_gray.png" alt="미작동" /> 미작동 : 1시간 이상 데이터 미수집 상태 지속
            시
          </span>
          <span style={{color : "#dc4747"}} className={styles.helpTxtLine}>
            &nbsp;&nbsp;&nbsp;&nbsp;설치예정 : 대상예정자
          </span>
          <span className={styles.helpTxtTitle}>{"<상태>"}</span>

          <span className={styles.helpTxtLine}> 고활동 : 30분 이상, 움직임이 30 이상 측정되는 경우</span>
          <span className={styles.helpTxtLine}> 저활동 : 30분 미만, 움직임이 30 이상 측정되는 경우</span>
          <span className={styles.helpTxtLine}>
            식사 : 움직임이 50 이상, CO<small>2</small>가 1500 이상, 조도가 11 이상으로 측정되는 경우
          </span>
          <span className={styles.helpTxtLine}> 단시간 자리비움 : 1시간 미만 움직임이 없는 경우</span>
          <span className={styles.helpTxtLine}> 장시간 자리비움 : 1시간 이상 움직임이 없는경우</span>
          <span className={styles.helpTxtLine}> 수면 : 움직임이 50 이하, 조도가 10 이하로 측정되는 경우</span>
          <span className={styles.helpTxtTitle}>{"<위험 대상자>"}</span>
          <span className={styles.helpTxtLine}>
            <img src="/images/icon_bell.png" style={{ width: "20px" }} alt="위험" /> &nbsp;당일 이전 일주일 내 위험 2회 이상 발생 개소
          </span>
          <span className={styles.helpTxtTitle}>{"<1차 설치제품>"}</span>
          <span className={styles.helpTxtLine}>
            <img src="/images/icon_set.png" style={{ width: "20px" }} alt="시제품" />
            &nbsp;시범사업 진행 시 설치한 시제품 기기(움직임·호흡·온도·습도·소리레벨 측정)
          </span>
        </div>
      </span> */}
    </div>
  );
};
export default AllStatusToolTip;
